/** author：胡枭 */

<template>
  <div class="layout-wrapper">
    <nav-bar class="layout-header" />

    <div class="main-container">
      <side-bar v-if="expandMenuList.length > 0" class="sidebar-container" />
      <transition name="fade-transform" mode="out-in">
        <app-main :class="{ container: expandMenuList.length > 0 }" />
      </transition>
    </div>
  </div>
</template>

<script>
import { SideBar, NavBar, AppMain } from './components'
import { mapGetters } from 'vuex'

export default {
  name: 'Layout',

  components: {
    SideBar,
    NavBar,
    AppMain
  },

  computed: {
    ...mapGetters('router', ['expandMenuList'])
  }
}
</script>

<style lang="scss" scoped>
.layout-wrapper {
  width: 100%;
  height: 100vh;

  .layout-header {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 1000;
  }

  .main-container {
    padding-top: $header-height;

    .sidebar-container {
      position: fixed;
      top: $header-height;
      left: 0;
      z-index: 999;
      height: calc(100vh - #{$header-height});
      width: $side-width;
      transition: width 0.28s;
      background-color: $white-color;
    }
    _:-ms-lang(x),
    .sidebar-container {
      width: $ie-side-width;
    }

    .container {
      margin-left: $side-width;
      transition: margin-left 0.28s;
      //width: calc(100% - #{$side-width});
    }
    _:-ms-lang(x),
    .container {
      margin-left: $ie-side-width;
      width: calc(100% - #{$ie-side-width});
    }
  }
}
</style>
